import { tsUtils } from '@neo-one/ts-utils';
import { Types } from '../../../constants';
import { BuiltinInstanceMemberCall } from '../../BuiltinInstanceMemberCall';
export class MapStorageIterator extends BuiltinInstanceMemberCall {
    canCall() {
        return true;
    }
    emitCall(sb, func, node, options, visited) {
        if (!options.pushValue) {
            if (visited) {
                sb.emitOp(node, 'DROP');
            }
            return;
        }
        if (!visited) {
            sb.visit(tsUtils.expression.getExpression(func), options);
        }
        sb.emitHelper(node, options, sb.helpers.createIterableIteratorStructuredStorage({ type: Types.MapStorage }));
    }
}

//# sourceMappingURL=iterator.js.map
